/**
 * Who may see the /jobs page.
 *
 * This is a UI convenience only — the job-monitor service enforces the same
 * allow-list on every request and returns 403 to anyone else. Matching is on
 * the authenticated email address, never on a display name.
 */
const JOB_ADMIN_EMAILS = [
  'gaurav.sultania@gmail.com',
  'shashank.nathani01@gmail.com',
];

export const isJobAdmin = (email: string | null | undefined): boolean =>
  !!email && JOB_ADMIN_EMAILS.includes(email.trim().toLowerCase());
